//
import Model from '@/models/Model'
import AMassiveCreateOffer from '@/models/Actions/AMassiveCreateOffer'
import AMassiveDeleteOffer from '@/models/Actions/AMassiveDeleteOffer'
import AMassiveEditOffer from '@/models/Actions/AMassiveEditOffer'
import SlDetailGroupedOffer from '@/models/Sale/SlDetailGroupedOffer'

/**
 * SlGroupedOffer
 * @class
 */
export default class SlGroupedOffer extends Model {
  /**
   * SlGroundOffer massive edit.
   * @param {Object} data 
   */
  create() {
    return AMassiveCreateOffer.post(this)
  }
  /**
   * SlGroundOffer massive edit.
   * @param {Object} data 
   */
  edit() {
    return AMassiveEditOffer.patch(this)
  }
  /**
   * SlGroundOffer massive edit.
   * @param {Object} data 
   */
  delete() {
    return AMassiveDeleteOffer.patch(this)
  }
  /**
   * SlGroupedOffer branch office name
   * @type {String}
   */
  get g_branch_office_name() {
    return this.getProperty('g_branch_office.name', '-')
  }
  /**
   * SlGroupedOffer selected items
   * @type {Array}
   */
  get sl_selected_grouped_offer() {
    return this.getProperty('sl_offers', []).map(this.mapSelected)
  }
  /**
   * Set sl_offers array
   */
  set sl_selected_grouped_offer(val) {
    return this.sl_offers = val
  }
  /**
   * 
   */
  mapDetail = item => ({
    finish_datetime: this.finish_datetime,
    init_datetime: this.init_datetime ,
    id: this.id,
    offer_price: item.offer_price,
    wh_product_id: item.wh_product_id,
  })
  /**
   * 
   */
  mapDetailToCreate = item => ({
    //finish_datetime: this.finish_datetime,
    //g_branch_office_id: 0,
    id: item.wh_product_id,
    //init_datetime: this.init_datetime,
    offer_price: item.offer_price,
    //wh_products: [],
  })
  /**
   * 
   */
  mapDetailToDelete = item => item.id
  /**
   * 
   */
  mapDetailToUpdate = item => ({
    finish_datetime: this.finish_datetime,
    //g_branch_office_id: 0,
    id: item.id,
    wh_product_id: item.wh_product_id,
    init_datetime: this.init_datetime,
    offer_price: item.offer_price,
    //wh_products: [],
  })
  /**
   * Mapping the SlGroupedOffer sl_offers items to SlDetailGroupedOffer
   * @return {Array}
   */
  mapSelected = item => {
    return new SlDetailGroupedOffer(item)
  }
  /**
   * SlGroundOffer massive edit.
   * @param {Object} data 
   */
  patch() {
    return AMassiveEditOffer.patch(this)
  }
  /**
   * SlGroundOffer reset.
   */
  reset() {
    //
    this.sl_offers = this.getProperty('sl_offers', []).map(this.mapSelected)
    //
    return this
  }
  /**
   * SlGroundOffer endpoint.
   * @return {String}
   */
  resource() {
    return 'sl_offer_grouped'
  }
  /**
   * 
   */
  setDiscount = (discount_percentage = 0) => {
    this.sl_offers.forEach(item => {
      item.discount_percentage = discount_percentage
      item.discount = discount_percentage / 100
      item.offer_price = Math.round(item.sale_price * ( 1 - item.discount ))
    })
  }
  /**
   * 
   */
  setPrice = (offer_price = 0) => {
    this.sl_offers.forEach(item => {
      item.discount = offer_price / item.sale_price
      item.discount_percentage = Math.round(item.discount * 100)
      item.offer_price = offer_price
    })
  }
  /**
   * 
   */
  toCreate(offers = []) {
    //
    let clone = this.clone()
    //
    clone.wh_products = clone.sl_offers.filter(item => !offers.some(offer => offer.id == item.id)).map(this.mapDetailToCreate)
    //
    clone.sl_offer_grouped_id = clone.id || null
    //
    return clone.clean([
      'name',
      'finish_datetime',
      'init_datetime',
      'g_branch_office_id',
      'offer_price',
      'wh_products',
      'sl_offer_grouped_id',
    ])
  }
  /**
   * 
   */
  toDelete(offers = []) {
    //
    let clone = this.clone()
    //
    clone.sl_offers = clone.sl_offers.filter(item => offers.every(offer => offer.id != item.id)).map(this.mapDetailToDelete)
    //
    return clone.clean([
      'name',
      'sl_offers',
    ])
  }
  /**
   * 
   */
  toUpdate() {
    //
    let clone = this.clone()
    //
    clone.sl_offers = clone.sl_offers.filter(item => item.name).map(this.mapDetailToUpdate)
    //
    return clone.clean([
      'name',
      'sl_offers',
    ])
  }
}
